<template>
    <div class="stage-indicator">
        <stage-status
            v-for="(stage, index) in stages"
            :key="`stage-${index}-${stage.label}`"
            :active="active(index)"
            :stage="stage"
            :stage-number="index + 1"
            @click.native="goToStage(index)"
            @go-to-stage="goToStage(index)"
        />
    </div>
</template>

<script>
import StageStatus from '@/components/broadcast/StageStatus';

export default {
    components: { StageStatus },

    props: {
        activeStage: Number,
        stages: {
            type: Array,
            default: () => [],
        },
    },

    methods: {
        active(index) {
            return this.activeStage === index;
        },

        goToStage(stageIndex) {
            this.$emit('go-to-stage', stageIndex);
        },
    },
};
</script>

<style lang="scss" scoped>
    .stage-indicator {
        display: inline-flex;
        margin-top: $spacing-200;

        @media($small) {
            margin: 0 0 $spacing-200;
        }
    }
</style>
